import styled from "styled-components";

export const StyledErrors = styled.div`
  padding-bottom: 10px;
  font-size: 16px;
  color: orange;
`;